// import React, { ComponentType } from 'react';
// /**
//  * https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
//  */
// import hoistNonReactStatics from 'hoist-non-react-statics';

// import { useStores } from './hook';

// export type TWithStoreHOC = <P extends unknown>(Component: ComponentType<P>) => (props: P) => JSX.Element;

// export const withStore: TWithStoreHOC = WrappedComponent => props => {
//   const ComponentWithStore = () => {
//     const store = useStores();

//     return <WrappedComponent {...props} store={store} />;
//   };

//   ComponentWithStore.defaultProps = { ...WrappedComponent.defaultProps };
//   ComponentWithStore.displayName = `WithStores(${WrappedComponent.name || WrappedComponent.displayName})`;

//   hoistNonReactStatics(ComponentWithStore, WrappedComponent);

//   return <ComponentWithStore />;
// };

import React, { ComponentType, FC } from 'react';
/**
 * https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
 */
import hoistNonReactStatics from 'hoist-non-react-statics';

import { useStores } from './hook';

export type TWithStoreHOC = <P extends object>(Component: ComponentType<P>) => ComponentType<Omit<P, 'store'>>;

export const withStore: TWithStoreHOC = WrappedComponent => {
  const ComponentWithStore: FC<Omit<React.ComponentProps<typeof WrappedComponent>, 'store'>> = props => {
    const store = useStores();

    return <WrappedComponent {...(props as React.ComponentProps<typeof WrappedComponent>)} store={store} />;
  };

  ComponentWithStore.defaultProps = WrappedComponent.defaultProps;
  // eslint-disable-next-line max-len
  ComponentWithStore.displayName = `WithStores(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  hoistNonReactStatics(ComponentWithStore, WrappedComponent);

  return ComponentWithStore;
};
